export default __webpack_public_path__ + "static/media/cfx-riu-2.28d7c7d2.png";